<template>
  <div class="v3-widget v3-feat-row" v-testid="testid">
    <div v-for="(t, i) in tiles" :key="i" class="v3-feat" :class="`v3-feat--${t.tone || 'accent'}`">
      <span class="v3-feat-ic"><span class="ms">{{ t.icon || 'star' }}</span></span>
      <h3 class="v3-feat-t">{{ t.title }}</h3>
      <p v-if="t.desc" class="v3-feat-d">{{ t.desc }}</p>
      <button v-if="t.cta && ctaAllowed(t)" type="button" class="v3-hero-btn" v-testid="testid + '-row-' + (t.destination || t.title)" @click="go(t)">{{ t.cta }}</button>
    </div>
  </div>
</template>

<script>
import { canNavigateTo } from "@/composables/useV3Nav";

// New-portal (v3) FeatureTiles — large promotional cards (prototype
// V3FeatureTiles): icon · title · description · CTA, in a tone (accent / indigo).
// Pure presentation. Sibling: rm-portal-beta FeatureTilesWidget.vue.
export default {
  name: "cLandingV3FeatureTiles",
  props: {
    definition: { type: Object, default: () => ({}) },
    editMode: { type: Boolean, default: false },
    qaActions: { type: Array, default: () => [] },
  },
  computed: {
    testid() {
      return this.definition.controlType || "v3FeatureTiles";
    },
    tiles() {
      return Array.isArray(this.definition.tiles) ? this.definition.tiles : [];
    },
  },
  methods: {
    // The card stays (it's content); its CTA is permission-gated — legacy
    // landing-config parity. The editor shows everything.
    ctaAllowed(t) {
      return this.editMode || !t.destination || canNavigateTo(this, t.destination);
    },
    go(t) {
      if (this.editMode) return;
      const dest = t.destination;
      if (!dest) return;
      if (dest === "create") {
        this.$emit("addDocument", "");
        return;
      }
      if (/^https?:\/\//i.test(dest)) {
        window.open(dest, "_blank");
        return;
      }
      this.$router.push({ name: dest }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" src="./v3Widgets.scss"></style>
